export default function StudyHarmonizationFlowchart() {
  return (
    <div className="text-center">
      <svg
        width="1350"
        height="500"
        viewBox="0 0 1350 500"
        style={{
          maxWidth: "100%",
          height: "auto",
          display: "block",
          margin: "0 auto",
        }}
      >
        {/* Define arrow markers */}
        <defs>
          <marker
            id="arrowhead"
            markerWidth="12"
            markerHeight="8"
            refX="11"
            refY="4"
            orient="auto"
            markerUnits="strokeWidth"
          >
            <polygon points="0 0, 12 4, 0 8" fill="#333" stroke="#333" />
          </marker>
          <marker
            id="arrowhead-red"
            markerWidth="12"
            markerHeight="8"
            refX="11"
            refY="4"
            orient="auto"
            markerUnits="strokeWidth"
          >
            <polygon points="0 0, 12 4, 0 8" fill="#DC2626" stroke="#DC2626" />
          </marker>
          <marker
            id="arrowhead-blue"
            markerWidth="12"
            markerHeight="8"
            refX="11"
            refY="4"
            orient="auto"
            markerUnits="strokeWidth"
          >
            <polygon points="0 0, 12 4, 0 8" fill="#2563EB" stroke="#2563EB" />
          </marker>
        </defs>

        {/* Study 1 Title */}
        <text x="120" y="30" fontSize="18" fontWeight="bold" fill="#DC2626" textAnchor="middle">
          Study 1
        </text>

        {/* Study 1 - Prestatistical harmonization */}
        <rect x="50" y="50" width="140" height="60" fill="white" stroke="#DC2626" strokeWidth="2" />
        <text x="120" y="75" textAnchor="middle" fontSize="12" fontWeight="bold" fill="#DC2626">
          Prestatistical
        </text>
        <text x="120" y="90" textAnchor="middle" fontSize="12" fontWeight="bold" fill="#DC2626">
          harmonization
        </text>

        {/* Study 1 - Harmonized items (rounded) */}
        <rect x="250" y="60" width="120" height="40" fill="white" stroke="#DC2626" strokeWidth="2" rx="20" />
        <text x="310" y="75" textAnchor="middle" fontSize="12" fontWeight="bold" fill="#DC2626">
          Harmonized
        </text>
        <text x="310" y="90" textAnchor="middle" fontSize="12" fontWeight="bold" fill="#DC2626">
          items
        </text>

        {/* Study 1 - IRT calibration */}
        <rect x="430" y="50" width="120" height="60" fill="white" stroke="#DC2626" strokeWidth="2" />
        <text x="490" y="70" textAnchor="middle" fontSize="11" fontWeight="bold" fill="#DC2626">
          IRT calibration to
        </text>
        <text x="490" y="83" textAnchor="middle" fontSize="11" fontWeight="bold" fill="#DC2626">
          estimate item
        </text>
        <text x="490" y="96" textAnchor="middle" fontSize="11" fontWeight="bold" fill="#DC2626">
          parameters
        </text>

        {/* All other studies - Prestatistical harmonization */}
        <rect x="50" y="200" width="140" height="60" fill="white" stroke="#2563EB" strokeWidth="2" />
        <text x="120" y="225" textAnchor="middle" fontSize="12" fontWeight="bold" fill="#2563EB">
          Prestatistical
        </text>
        <text x="120" y="240" textAnchor="middle" fontSize="12" fontWeight="bold" fill="#2563EB">
          harmonization
        </text>

        {/* All other studies - Harmonized items (rounded) */}
        <rect x="250" y="210" width="120" height="40" fill="white" stroke="#2563EB" strokeWidth="2" rx="20" />
        <text x="310" y="225" textAnchor="middle" fontSize="12" fontWeight="bold" fill="#2563EB">
          Harmonized
        </text>
        <text x="310" y="240" textAnchor="middle" fontSize="12" fontWeight="bold" fill="#2563EB">
          items
        </text>

        {/* All other studies - IRT calibration */}
        <rect x="430" y="200" width="120" height="60" fill="white" stroke="#2563EB" strokeWidth="2" />
        <text x="490" y="220" textAnchor="middle" fontSize="11" fontWeight="bold" fill="#2563EB">
          IRT calibration to
        </text>
        <text x="490" y="233" textAnchor="middle" fontSize="11" fontWeight="bold" fill="#2563EB">
          estimate item
        </text>
        <text x="490" y="246" textAnchor="middle" fontSize="11" fontWeight="bold" fill="#2563EB">
          parameters
        </text>

        {/* DIF detection box */}
        <rect x="630" y="200" width="120" height="60" fill="white" stroke="#2563EB" strokeWidth="2" />
        <text x="690" y="220" textAnchor="middle" fontSize="11" fontWeight="bold" fill="#2563EB">
          DIF detection to
        </text>
        <text x="690" y="233" textAnchor="middle" fontSize="11" fontWeight="bold" fill="#2563EB">
          identify and adjust
        </text>
        <text x="690" y="246" textAnchor="middle" fontSize="11" fontWeight="bold" fill="#2563EB">
          for remaining bias
        </text>

        {/* ITEM BANK (central) */}
        <rect x="820" y="100" width="140" height="120" fill="white" stroke="#333" strokeWidth="3" rx="15" />
        <text x="890" y="150" textAnchor="middle" fontSize="18" fontWeight="bold" fill="#333">
          ITEM
        </text>
        <text x="890" y="170" textAnchor="middle" fontSize="18" fontWeight="bold" fill="#333">
          BANK
        </text>

        {/* Latent trait estimation */}
        <rect x="1020" y="130" width="120" height="60" fill="white" stroke="#333" strokeWidth="2" />
        <text x="1080" y="155" textAnchor="middle" fontSize="12" fontWeight="bold" fill="#333">
          Latent trait
        </text>
        <text x="1080" y="170" textAnchor="middle" fontSize="12" fontWeight="bold" fill="#333">
          estimation
        </text>

        {/* Final harmonized data */}
        <rect x="1180" y="140" width="140" height="40" fill="white" stroke="#333" strokeWidth="2" rx="20" />
        <text x="1250" y="155" textAnchor="middle" fontSize="11" fontWeight="bold" fill="#333">
          Harmonized,
        </text>
        <text x="1250" y="168" textAnchor="middle" fontSize="11" fontWeight="bold" fill="#333">
          pooled data
        </text>

        {/* All other studies label */}
        <text x="120" y="180" fontSize="16" fontWeight="bold" fill="#2563EB" textAnchor="middle">
          All other
        </text>
        <text x="120" y="195" fontSize="16" fontWeight="bold" fill="#2563EB" textAnchor="middle">
          studies
        </text>

        {/* Legend */}
        <g transform="translate(500, 350)">
          <rect x="0" y="0" width="20" height="15" fill="white" stroke="#333" strokeWidth="2" />
          <text x="30" y="12" fontSize="12" fill="#333">
            Process
          </text>

          <rect x="100" y="0" width="20" height="15" fill="white" stroke="#333" strokeWidth="2" rx="7.5" />
          <text x="130" y="12" fontSize="12" fill="#333">
            Data
          </text>
        </g>

        {/* Arrows - Study 1 flow */}
        <line x1="190" y1="80" x2="245" y2="80" stroke="#333" strokeWidth="2" markerEnd="url(#arrowhead)" />
        <line x1="370" y1="80" x2="425" y2="80" stroke="#333" strokeWidth="2" markerEnd="url(#arrowhead)" />
        <line x1="550" y1="80" x2="815" y2="140" stroke="#333" strokeWidth="2" markerEnd="url(#arrowhead)" />

        {/* Arrows - All other studies flow */}
        <line x1="190" y1="230" x2="245" y2="230" stroke="#333" strokeWidth="2" markerEnd="url(#arrowhead)" />
        <line x1="370" y1="230" x2="425" y2="230" stroke="#333" strokeWidth="2" markerEnd="url(#arrowhead)" />
        <line x1="550" y1="230" x2="625" y2="230" stroke="#333" strokeWidth="2" markerEnd="url(#arrowhead)" />
        <line x1="750" y1="230" x2="815" y2="180" stroke="#333" strokeWidth="2" markerEnd="url(#arrowhead)" />

        {/* Arrow from Item Bank to Latent trait estimation */}
        <line x1="960" y1="160" x2="1015" y2="160" stroke="#333" strokeWidth="2" markerEnd="url(#arrowhead)" />

        {/* Arrow from Latent trait estimation to final data */}
        <line x1="1140" y1="160" x2="1175" y2="160" stroke="#333" strokeWidth="2" markerEnd="url(#arrowhead)" />

        {/* Arrow from DIF detection back to All other studies text */}
        <path
          d="M 630 250 Q 580 280 500 290 Q 400 310 350 340"
          fill="none"
          stroke="#333"
          strokeWidth="2"
          markerEnd="url(#arrowhead)"
        />

        {/* Text "All other studies" */}
        <text x="350" y="360" fontSize="14" fontWeight="bold" fill="#2563EB" textAnchor="middle">
          All other studies
        </text>

        {/* Arrow from "All other studies" text to prestatistical harmonization box */}
        <path
          d="M 320 370 Q 250 380 180 350 Q 120 320 120 260"
          fill="none"
          stroke="#333"
          strokeWidth="2"
          markerEnd="url(#arrowhead)"
        />
      </svg>
    </div>
  );
}
